// TODO -- refactor this with @ori/presentation-translations
import { createContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export var translationsContextDefaultValue = {
  modalTitle: 'Share and Copy',
  openWeChatClickDiscover: 'OpenWeChatClickDiscover',
  shareToWeChat: 'shareToWeChat',
  copy: 'Copy link',
  linkCopied: 'Link copied'
};
export var translationsContext = /*#__PURE__*/createContext(translationsContextDefaultValue);
var Provider = translationsContext.Provider;
export var TranslationsProvider = function TranslationsProvider(_ref) {
  var children = _ref.children,
    value = _ref.value;
  return value ? /*#__PURE__*/_jsx(Provider, {
    value: value,
    children: children
  }) : children;
};
//# sourceMappingURL=translationsContext.js.map